module.exports = __webpack_public_path__ + "static/img/about_slider1_bg.62e8e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/about_slider1_bg.jpg
// module id = 318
// module chunks = 2